<template>
  <b-container v-if="!isLoggedIn">
    <h4 class="notAllowed text-center">
      No puedes ver nuestros productos si no estas registrado.
      Para registrarte llama al 953741829 y hazte cliente.
    </h4>
  </b-container>

  <b-container v-else>
    <b-row class="my-5 product-div" v-for="(model, index) in product" :key="index">
      <b-col class="xs-hidden sm-hidden p-0">
        <!-- Base (sin color) -->
        <ProductZoomer
          v-if="!id_color && imagesReady"
          :key="'base-'+imagesKey"
          :base-images="images"
          :base-zoomer-options="zoomerOptions"
        />
        <!-- Con color -->
        <ProductZoomer
          v-else-if="id_color && colorImagesReady"
          :key="'color-'+id_color+'-'+colorImagesKey"
          width="500"
          :base-images="colorImages"
          :base-zoomer-options="colorZoomerOptions"
        />
        <!-- Fallback mientras se construyen o si no hay normal_size disponible aún -->
        <b-img
          v-else
          class="mx-auto product-img"
          center
          thumbnail
          fluid
          :src="fallbackSrc"
        />
      </b-col>

      <b-col class="text-product">
        <div v-if="model.ruta2 === null" class="md-hidden lg-hidden xl-hidden">
          <b-img
            class="mx-auto product-img"
            center
            thumbnail
            fluid
            :src="'https://ctworker.com/images/normal_size/' + model.modelo + '.jpg'"
          />
        </div>
        <div v-else class="md-hidden lg-hidden xl-hidden">
          <agile>
            <div class="slide hoverHand h-100" v-for="n in 2" :key="n">
              <div v-if="n === 1">
                <b-img
                  class="mx-auto product-img"
                  center
                  thumbnail
                  fluid
                  :src="'https://ctworker.com/images/normal_size/' + model.modelo + '.jpg'"
                />
              </div>
              <div v-else-if="n === 2">
                <b-img
                  class="mx-auto product-img"
                  center
                  thumbnail
                  fluid
                  :src="'https://ctworker.com/images/normal_size/' + model.modelo + '_back.jpg'"
                />
              </div>
            </div>
            <template #prevButton><i class="fas fa-chevron-left"></i></template>
            <template #nextButton><i class="fas fa-chevron-right"></i></template>
          </agile>
        </div>

        <h3 class="mx-auto text-center pr-width-title px-0 mt-md-0 mt-lg-0 formTitle">
          Modelo {{ model.modelo }}
        </h3>

        <div class="formTitle pr-width-title mx-auto mt-2 text-center">
          <h6>{{ model.descripcion }}</h6>
          <h6 v-if="model.tallas === 'Única'">Talla {{ model.tallas }}</h6>
          <h6 v-else>Tallas: {{ ' ' + model.tallas }}</h6>
          <h6 class="bg-info w-50 mx-auto" style="color:white" v-if="model.new === 1" id="newSeason">Nueva temporada</h6>
          <h6 class="text-info" v-if="model.new === 1 && model.temporada == 'Verano'">
            <hr>
            Todos los productos de la colección verano 2026 están disponibles en modalidad preventa.
            Los pedidos se entregarán durante los meses de febrero y marzo.
            La preventa estará abierta hasta el 15 de octubre.
            <hr>
          </h6>
          <h6 class="pt-2" v-if="model.precio_rebaja > 0 && model.new === 0">
            Precio anterior <del class="text-danger">{{ model.precio }} €</del>
          </h6>
          <h6 class="pt-2" v-if="model.precio_rebaja > 0 && model.new === 0">Precio {{ model.precio_rebaja }} €</h6>
          <h6 class="pt-2" v-else>Precio {{ model.precio }} €</h6>
        </div>

        <div class="mt-5" v-if="(model.temporada == 'Invierno' && model.año == '2026')">
          <h6 class="text-danger text-center pr-width-title">
            <hr>
            La preventa ha finalizado, estamos en el proceso de producción.
            Una vez enviemos todos los pedidos a nuestros clientes, abriremos el stock en octubre.
          </h6>
        </div>

        <div class="input-field mx-auto pr-width-title mt-2">
          <b-form v-if="(model.temporada === 'Invierno' && model.año !== 2026 || model.temporada === 'Verano')"
            @submit.prevent="addToBasket(id_color, talla, model.precio, model.precio_rebaja, model.temporada, model.familia, model.año, model.tipo)"
          >
            <select v-model="id_color" name="color" id="color" class="form-control select h-25" tabindex="12" required>
              <b-form-select-option value="" disabled>-- Color --</b-form-select-option>
              <b-form-select-option
                v-for="(id_color, colorIndex) in productQuantity"
                :key="colorIndex"
                :value="id_color.id_color + id_color.color"
              >
                {{ id_color.color }}
              </b-form-select-option>
            </select>

            <div v-if="model.tallas.indexOf('meses') != -1 && id_color != ''">
              <select :talla="talla" v-model="talla" name="talla" id="talla" class="form-control select h-25 mt-3" tabindex="12" required>
                <b-form-select-option value="" disabled>-- Talla --</b-form-select-option>
                <b-form-select-option v-for="(size, tallasIndex) in sizes" :key="tallasIndex" :value="size">
                  {{ size }}<span v-if="size === 1"> mes</span><span v-else> meses</span>
                </b-form-select-option>
              </select>
            </div>

            <div v-else-if="model.tallas.indexOf('años') != -1 && id_color != ''">
              <select :talla="talla" v-model="talla" name="talla" id="talla" class="form-control select h-25 mt-3" tabindex="12" required>
                <b-form-select-option value="" disabled>-- Talla --</b-form-select-option>
                <b-form-select-option v-for="(size, tallasIndex) in sizes" :key="tallasIndex" :value="size">
                  {{ size }} <span v-if="size === 1"> año</span><span v-else> años</span>
                </b-form-select-option>
              </select>
            </div>

            <div v-else-if="id_color == ''">
              <select :talla="talla" v-model="talla" name="talla" id="talla" class="form-control select h-25 mt-3" tabindex="12" required>
                <b-form-select-option value="" disabled>-- Talla --</b-form-select-option>
                <b-form-select-option value="" disabled>Elige un color</b-form-select-option>
              </select>
            </div>

            <select :talla="talla" v-model="talla" v-else-if="model.tallas.indexOf('Única') != -1" name="talla" id="talla" class="form-control select h-25 mt-3" tabindex="12" required>
              <b-form-select-option value="" disabled>-- Talla --</b-form-select-option>
              <b-form-select-option value="unica">Talla Única</b-form-select-option>
            </select>

            <b-form-group id="input-group-2" class="form-control select h-25 mt-3">
              <b-form-input id="cantidad" class="form-control select ml-2 h-25 border-0" v-model="quantity" required placeholder="--Cantidad--" type="number" min="1" />
            </b-form-group>

            <span>{{ quantities() }}</span>
            <span :class="'quantities text-right mt-5 ml-1 text-' + textColor">{{ quantityInfo }}</span>

            <b-alert variant="success" class="alert" :show="dismissCountDown" @dismissed="dismissCountDown = 0">
              Producto añadido a su cesta
            </b-alert>
            <b-alert variant="warning" class="alert" :show="dismissCountDown3" @dismissed="dismissCountDown3 = 0">
              Añada este producto a un pedido con productos sólo de nueva temporada
            </b-alert>
            <b-alert variant="warning" class="alert" :show="dismissCountDown4" @dismissed="dismissCountDown4 = 0">
              Tiene productos de nueva temporada en su cesta. Añada este producto a un pedido con productos que no sean de nueva temporada
            </b-alert>

            <b-button :disabled="isDisabled" type="submit" class="mt-4 mx-auto d-block btn-form" variant="primary">
              Añadir a la cesta
            </b-button>
          </b-form>

          <b-alert variant="danger" class="alert" :show="dismissCountDown2" @dismissed="dismissCountDown2 = 0">
            Ha habido un error! Por favor recargue la página
          </b-alert>
        </div>
      </b-col>
    </b-row>

    <router-link
      class="link text-center py-5"
      :to="{ name: 'Family', params: { season: $route.params.season, family: $route.params.family } }"
    >
      Volver a {{ family }}
    </router-link>
  </b-container>
</template>

<script>
export default {
  name: 'Product',
  props: { fixNumber: Function },
  data() {
    return {
      n: 0,
      inCart: [],
      dismissSecs: 2,
      dismissSecs2: 8,
      dismissCountDown: 0,
      dismissCountDown2: 0,
      dismissCountDown3: 0,
      dismissCountDown4: 0,
      isLoggedIn: localStorage.getItem('tbStore.jwt') && localStorage.getItem('tbStore.user') != null,
      quantity: '',
      id_color: '',
      talla: '',
      family: this.$route.params.family.replace('_', ' '),
      textColor: '',
      quantityInfo: '',
      modelo: this.$route.params.product,
      productQuantity: [],
      product: [],
      isDisabled: false,

      // se rellenan dinámicamente
      images: { thumbs: [], normal_size: [], large_size: [] },
      colorImages: { thumbs: [], normal_size: [], large_size: [] },

      colorZoomerOptions: {
        zoomFactor: 3,
        pane: 'pane',
        hoverDelay: 300,
        zoomer_pane_position: 'right',
        namespace: 'zoomer',
        move_by_click: true,
        scroll_items: 2,
        choosed_thumb_border_color: '#b3d7dd',
        scroller_position: 'bottom'
      },

      zoomerOptions: {
        zoomFactor: 3,
        pane: 'pane',
        hoverDelay: 300,
        zoomer_pane_position: 'right',
        namespace: 'zoomer',
        move_by_click: true,
        scroll_items: 6,
        choosed_thumb_border_color: '#b3d7dd',
        scroller_position: 'bottom'
      }
    }
  },

  created() {
    this.$root.$emit('loader', true)
    this.axios.get('getProductInfo/' + this.$route.params.product + '/tony').then(response => {
      if (response.status === 200) {
        this.product = response.data
        this.$root.$emit('loader', false)
      }
    })
    this.axios.get('getProductSizes/' + this.$route.params.product).then(r => (this.productQuantity = r.data))
    this.axios.get('getItemsFromCartByUser/' + this.$store.getters.username).then(r => (this.inCart = r.data))
  },

  computed: {
    sizes() {
      if (!this.product.length) return []
      let sizes = this.product[0].tallas

      sizes = sizes.replace('y', ',').replace('meses', '').split(',').map(x => parseInt(x, 10))

      if (this.product[0].new !== 1) {
        const arr = []
        const color = this.productQuantity.find(x => x.id_color + x.color === this.id_color)
        if (!color) return []
        for (let j = 0; j < sizes.length; j++) {


          if (color['talla_' + sizes[j]]) arr.push(sizes[j])

        }
        return arr
      }
      return sizes
    },

    // flags para montar/desmontar el zoomer sin error
    imagesReady() {
      return this.images?.normal_size?.length > 0
    },
    colorImagesReady() {
      return this.colorImages?.normal_size?.length > 0
    },
    imagesKey() {
      return this.images?.normal_size?.length || 0
    },
    colorImagesKey() {
      return (this.colorImages?.normal_size?.length || 0) + (this.id_color || '')
    },
    fallbackSrc() {
      const model = this.$route.params.product
      if (this.id_color) {
        const colorId = this.id_color.slice(0, 2)
        return `https://ctworker.com/images/normal_size/${model}_C${colorId}.jpg`
      }
      return `https://ctworker.com/images/normal_size/${model}.jpg`
    }
  },

  watch: {
    // construir imágenes al cargar y cuando cambie el color
    id_color: {
      immediate: true,
      async handler(val) {
        const model = this.$route.params.product
        if (!val) {
          this.images = { thumbs: [], normal_size: [], large_size: [] } // limpia para desmontar zoomer
          this.images = await this.buildImages(model)
          this.colorImages = { thumbs: [], normal_size: [], large_size: [] }
        } else {
          const colorId = val.slice(0, 2) // tu id_color es "id+nombre"
          this.colorImages = { thumbs: [], normal_size: [], large_size: [] } // limpia para desmontar
          const built = await this.buildImages(model, colorId)
          // si no hay imágenes de ese color, quedarnos con las base para no dejar en blanco
          this.colorImages = built.normal_size.length ? built : this.images
        }
      }
    }
  },

  methods: {
    // comprobar existencia (onload/onerror no rompe por CORS)
    preload(url) {
      return new Promise(resolve => {
        const img = new Image()
        img.onload = () => resolve(true)
        img.onerror = () => resolve(false)
        img.src = url
      })
    },

    // construir arrays sincronizados y con fallbacks por tamaño
    async buildImages(model, colorId = '') {
      const suffixes = ['', '_back', '_child_1', '_child_2', '_child_3', '_child_4']
      const urlOf = (size, suf) =>
        colorId
          ? `https://ctworker.com/images/${size}/${model}_C${colorId}${suf}.jpg`
          : `https://ctworker.com/images/${size}/${model}${suf}.jpg`

      const result = { thumbs: [], normal_size: [], large_size: [] }
      let idCounter = 1

      for (const suf of suffixes) {
        const tURL = urlOf('thumbs', suf)
        const nURL = urlOf('normal_size', suf)
        const lURL = urlOf('large_size', suf)

        const [tOK, nOK, lOK] = await Promise.all([this.preload(tURL), this.preload(nURL), this.preload(lURL)])

        // si no hay ni normal ni large, no añadimos este sufijo (ProductZoomer necesita al menos normal/large)
        if (!nOK && !lOK) continue

        const chosenNormal = nOK ? nURL : lURL       // si falta normal, usa large
        const chosenLarge  = lOK ? lURL : nURL       // si falta large, usa normal
        const chosenThumb  = tOK ? tURL : (nOK ? nURL : lURL) // si falta thumb, usa normal/large

        result.thumbs.push({ id: idCounter, url: chosenThumb })
        result.normal_size.push({ id: idCounter, url: chosenNormal })
        result.large_size.push({ id: idCounter, url: chosenLarge })
        idCounter++
      }

      // Fallback total: si no entró nada (muy raro), intenta al menos frontal ""
      if (result.normal_size.length === 0) {
        const baseT = urlOf('thumbs', '')
        const baseN = urlOf('normal_size', '')
        const baseL = urlOf('large_size', '')
        const [tOK, nOK, lOK] = await Promise.all([this.preload(baseT), this.preload(baseN), this.preload(baseL)])
        if (nOK || lOK) {
          result.thumbs.push({ id: 1, url: tOK ? baseT : (nOK ? baseN : baseL) })
          result.normal_size.push({ id: 1, url: nOK ? baseN : baseL })
          result.large_size.push({ id: 1, url: lOK ? baseL : baseN })
        }
      }

      return result
    },

    setInputsBlank() {
      this.dismissCountDown = this.dismissSecs
      this.talla = ''
      this.id_color = ''
      this.quantity = ''
    },

    createItemForBasket(id_color, talla, precio, precio_rebaja, temporada, familia, año, description, sizes) {
      let precio_final = precio_rebaja > 0 ? precio_rebaja : precio
      const item = {
        modelo: this.modelo,
        id_color: id_color.slice(0, 2),
        color: id_color.slice(2),
        talla: talla,
        cantidad: parseInt(this.quantity),
        id: this.modelo + id_color.trim() + talla,
        precio: parseFloat(precio_final),
        season: temporada,
        family: familia,
        year: año,
        new: this.product[0].new,
        description: description,
        sizes: sizes
      }
      return item
    },

    addToBasket(id_color, talla, precio, precio_rebaja, temporada, familia, año, description) {
      let sizes = 0
      let matchSales = this.inCart.find(item => item.new === 0)
      let matchNew = this.inCart.find(item => item.new === 1)

      if (temporada === 'Verano' && año === '2026') return alert('Las ventas en esta temporada no están disponibles')
      if (!localStorage) {
        return alert('No puede realizar pedidos con este navegador. Utilice Chrome, Opera o Mozilla')
      }

      if (this.product[0].new === 1 && matchSales) return (this.dismissCountDown3 = this.dismissSecs2)
      if (this.product[0].new === 0 && matchNew) return (this.dismissCountDown4 = this.dismissSecs2)

      if (this.product[0].tallas.indexOf('años') != -1) sizes = 1

      let user = this.$store.getters.username
      let item = this.createItemForBasket(id_color, talla, precio, precio_rebaja, temporada, familia, año, description, sizes)

      this.axios.post('storeOrUpdateItemInCart', { user, item }).catch(error => {
        if (error.response?.status) this.dismissCountDown2 = this.dismissSecs
      })

      this.$store.dispatch('addToCart', parseInt(this.quantity))
      this.setInputsBlank()
    },

    quantities() {
      if (!this.product.length) return
      if ((this.talla === 0 && this.product[0].new === 0) || (this.talla && this.product[0].new === 0)) {
        let quantity = parseInt(this.quantity)
        let idInCart = this.$store.getters.inCartItems.find(
          x => x.id === this.modelo + this.id_color.trim() + this.talla
        )
        let stockQuantityPerSize = 0

        if (idInCart) quantity = idInCart['cantidad'] + quantity
        if (this.productQuantity.length > 0) {
          stockQuantityPerSize = this.productQuantity.find(x => x.id_color + x.color === this.id_color)['talla_' + this.talla]
        }

        let remainQuantity = stockQuantityPerSize - quantity

        if (remainQuantity < 0) {
          this.isDisabled = true
          this.quantityInfo = 'No disponemos de la cantidad que ha elegido'
          this.textColor = 'danger'
        } else if (remainQuantity > 0) {
          this.isDisabled = false
          this.quantityInfo = 'Quedan ' + remainQuantity + ' unidades de este modelo'
          this.textColor = 'info'
        } else {
          this.isDisabled = false
          this.quantityInfo = 'Son las ultimas ' + this.quantity + ' unidades'
          this.textColor = 'danger'
        }
      }
    }
  },

  mounted() {
    document.title = 'Tony Bambino: modelo ' + this.$route.params.product
  }
}
</script>

<style scoped>
/* Centrar thumbnails (grid del plugin) */
::v-deep(.thumb-list) {
  display: grid !important;
  justify-content: center;
  justify-items: center;
  gap: 8px;
}

/* Flechas debajo y centradas */
::v-deep(.thumb-list + .control) {
  grid-column: 1 / -1;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

/* Evitar “zona fantasma” clicable */
::v-deep(.control) {
  pointer-events: none;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  gap: 12px;
}
::v-deep(.control svg) {
  pointer-events: auto;
  cursor: pointer;
  width: 20px;
  height: 20px;
  fill: #333;
}
</style>
